module.exports = __webpack_public_path__ + "img/69be1613a1b303d229cfc53ed99ee3b1.png";